module.exports = __webpack_public_path__ + "static/img/hgzs.9be8986.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hgzs.png
// module id = Bo7Y
// module chunks = 0